import React from 'react';
import hotelcss from '../pages/css/hotelhotellist.module.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useState } from 'react';
import { useEffect } from 'react';
import {
    getView, getCleaningtasks
} from "../dbconnector/connector";
import { setErrorMessage, setMessage, clearMessage } from "../tools/errorhandling";

import { CgCloseR } from "react-icons/cg";
import { GoTasklist } from 'react-icons/go';
import { json } from 'react-router-dom';
import moment from 'moment'
import { FaRegThumbsDown } from 'react-icons/fa';
import { FaRegThumbsUp } from 'react-icons/fa';
//import { Tooltip } from 'bootstrap';
import { Tooltip } from 'react-tooltip'
import { RiAlarmWarningLine } from 'react-icons/ri';

const Dagstaat_per_medewerker = ({ rights, t, hotelid, selecteddate, events }) => {

    const [dagstaatoverzicht, setDagstaatoverzicht] = useState([]);
    const [dagstaatoverzicht_employee, setDagstaatoverzicht_Employee] = useState([]);
    const [selectedemployee, setSelectedemployee] = useState(undefined);
    const [generalservicestasks, setGeneralservicestasks] = useState([]);
    const [assignedUSer, setAssignedUSer] = useState(false);


    useEffect(() => {
        if (assignedUSer !== false &&  generalservicestasks !== undefined) {
            getemployeedata(assignedUSer)
        }
    }, [generalservicestasks, assignedUSer])


    useEffect(() => {

        setDagstaatoverzicht_Employee([]);
        if (hotelid !== null && selecteddate !== undefined) {
            Getgeneralservicestasks(hotelid);
            document.getElementById("FullscreenBlocker").style.display = "block";
            document.getElementById("employeedetails").style.display = "none";
            document.getElementById("RotatinglinesText").innerText = "data wordt opgehaald, even geduld"
            document.getElementById("dagstaatpermedewerker").style.display = "none"
            const fields = '["hotel_Id" , "creationdate"]';
            const values = `[${hotelid},"${selecteddate}"]`;

            getView("dagrapport_employee", fields, values).then((res) => {
                if (res.status === 200) {
                    res.json().then(body => {
                        if (body.length > 0) {
                            body.forEach((item, index) => {
                                setDagstaatoverzicht_Employee(pre => [...pre,
                                <div className='dagstaat_medewerkerform' onClick={() => setAssignedUSer(item.assignee_Id)}>
                                    <p className='dagstaatparagraaf'>{item.assignedto}</p>
                                    <p className='dagstaatparagraaf'>{item.aantal}</p>
                                    <div style={Number(item.payed_task) === 0 ? { visibility: 'hidden' } : { visibility: 'visible' }} data-tooltip-id="overallpt" data-tooltip-content={"Betalende taken gedetecteerd"}><GoTasklist /> <Tooltip id="overallpt"></Tooltip></div>
                                    <p className='dagstaatparagraaf dagstaat_rightalign'>{Number(item.norm).toFixed(0)} min</p>
                                    <p className='dagstaatparagraaf dagstaat_rightalign'>{Number(item.timespend).toFixed(0)} min</p>
                                    <p className='dagstaatparagraaf'>
                                        <div style={Number(item.result) > 0 || item.timespend <= (Number(item.norm)) / 3 ? { display: "none" } : { display: "block" }}><FaRegThumbsDown className='dagstaat_room_statuscolor_red' /></div>
                                        <div style={Number(item.result) <= 0 || item.timespend <= (Number(item.norm)) / 3 ? { display: "none" } : { display: "block" }}><FaRegThumbsUp className='dagstaat_room_statuscolor_green' /></div>
                                        <div style={item.timespend <= (Number(item.norm)) / 3 ? { display: "block" } : { display: "none" }}><RiAlarmWarningLine className='dagstaat_room_statuscolor_orange' /></div>
                                    </p>
                                </div>
                                ])
                            })
                        }
                    })
                    document.getElementById("dagstaatpermedewerker").style.display = "block"
                    document.getElementById("FullscreenBlocker").style.display = "none";
                } else {
                    //console.log(res.statusText)
                    setErrorMessage(res.statusText)
                    document.getElementById("coverAll").style.display = "none";
                    document.getElementById("dagstaatpermedewerker").style.display = "none"
                }

            })
        }
    }, [hotelid, selecteddate])

    const Getgeneralservicestasks = (hotelid) => {
        if (hotelid) {
            setGeneralservicestasks([])
            getCleaningtasks(hotelid, 1).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        console.log(body.items)
                        setGeneralservicestasks(body.items)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
        }
    }
    const getemployeedata = (employeeid) => {
//        console.log("getemployee data general services tasks", generalservicestasks)

        if (hotelid !== null && selecteddate !== undefined) {
            document.getElementById("FullscreenBlocker").style.display = "block";
            //assignmentDetailsNode
            document.getElementById("assignmentDetailsNode").style.display = "none";
            document.getElementById("employeedetails").style.display = "none";
            document.getElementById("RotatinglinesText").innerText = "data wordt opgehaald, even geduld"
            const fields = '["hotel_Id","creationdate","assignee_Id"]';
            const values = `[${hotelid},"${selecteddate}",${employeeid}]`;
            getView("dagrapport_employee_by_room", fields, values).then((res) => {
                if (res.status === 200) {
                    setDagstaatoverzicht([]);
                    res.json().then(body => {
                        if (body.length > 0) {
                            body.forEach((item, index) => {
                                let extratasksduration = 0;
                                var extrataskdescription = "no extra tasks"
                               
                                if (item.multiple !== "{}") {
                                    extrataskdescription = ""
                                    let multipletasks = JSON.parse(item.multiple)
                                    const filteredkeys = Object.keys(multipletasks)
                                    filteredkeys.forEach((key) => {
                                        const taskitem = generalservicestasks.find((taak) => taak.Id === Number(key))
                                        if (taskitem) {
                                            var tasktijd = (60 / Number(taskitem.taskDuration)* Number(multipletasks[key]) )
                                            extratasksduration = Number(extratasksduration) + tasktijd
                                            extrataskdescription =  "[" + Number(multipletasks[key]) + " x '" + taskitem.taskDescription + "': " + tasktijd.toFixed(0) + " min extra ], " + extrataskdescription
                                        }
                                    })
                                }else if (item.tasks !== "")
                                {
                                    const taskitem = generalservicestasks.find((taak) => taak.Id === Number(item.tasks))
                                    if (taskitem) {
                                        extratasksduration = 60 / Number(taskitem.taskDuration)
                                        extrataskdescription = "1 x '" + taskitem.taskDescription + "': " + extratasksduration.toFixed(0) + " min extra"
                                    }
                                }
                                setDagstaatoverzicht(pre => [...pre,
                                <div className='dagstaat_medewerkerdetailform' onClick={(e) => events.showdetails(item, true, e)} >
                                    <p className='dagstaatparagraaf'>{item.assignedto}</p>
                                    <p className='dagstaatparagraaf' data-tooltip-id="roomtt" data-tooltip-content={item.roomnumber}>{item.roomnumber}</p>
                                    <div style={item.payed_task === 0 ? { visibility: 'hidden' } : { visibility: 'visible' }} data-tooltip-id="roomtt" data-tooltip-content={extrataskdescription}><GoTasklist /><Tooltip id="roomtt"></Tooltip>

                                    </div>
                                    <p className='dagstaatparagraaf dagstaat_rightalign'>{(Number(item.norm) + Number(extratasksduration)).toFixed(0)} min.</p>
                                    <p className='dagstaatparagraaf dagstaat_rightalign'>{item.timespend} min.
                                    </p>
                                    <p>
                                        <div style={(Number(item.result) + Number(extratasksduration)) > 0 || item.timespend <= (Number(item.norm) + Number(extratasksduration)) / 3 ? { display: "none" } : { display: "block" }}><FaRegThumbsDown className='dagstaat_room_statuscolor_red' /></div>
                                        <div style={(Number(item.result) + Number(extratasksduration)) <= 0 || item.timespend <= (Number(item.norm) + Number(extratasksduration)) / 3 ? { display: "none" } : { display: "block" }}><FaRegThumbsUp className='dagstaat_room_statuscolor_green' /></div>
                                        <div style={item.timespend <= (Number(item.norm) + Number(extratasksduration)) / 3 ? { display: "block" } : { display: "none" }}><RiAlarmWarningLine className='dagstaat_room_statuscolor_orange' /></div>
                                    </p>
                                    <p className='dagstaatparagraaf dagstaat_rightalign'>{item.type === 0 ? "Blijver" : item.type === -1 ? "Algemene dienst" : item.type === -2 ? "Speciale aanvraag" : "Vertrekker"}</p>
                                </div>
                                ])
                            })
                        }
                    })
                    document.getElementById("FullscreenBlocker").style.display = "none";
                    document.getElementById("employeedetails").style.display = "block";
                } else {
                    setErrorMessage(res.statusText)
                    document.getElementById("FullscreenBlocker").style.display = "none";
                }

            })
        }

    }

    const handleCancel = (e) => {
        setAssignedUSer(false)
         events.startdrag(null, false, e)
        events.handleCancel(e);
    }


    return (
        <>
            <div id="dagstaatpermedewerker" className='employeereportdiv' style={dagstaatoverzicht_employee === undefined ? { display: 'none' } : { display: 'block' }}>
                <div className='form_dagstaat' onMouseDown={(e) => events.startdrag("dagstaatpermedewerker", true, e)} onMouseUp={(e) => events.startdrag(null, false, e)}>{t('dagnormen - activiteitenrapport')} <CgCloseR className='closer' onClick={handleCancel} /></div>
                <div className='dagstaat_medewerkerformHeader'> <p className='dagstaatparagraaf'>Medewerker</p><p className='dagstaatparagraaf'>Kamers/AD</p><p></p><p className='dagstaatparagraaf dagstaat_rightalign'>norm</p><p className='dagstaatparagraaf dagstaat_rightalign'>cum. taakduur</p><p className='dagstaatparagraaf'></p></div>
                <div className='dagstaat_form'>
                    <div className='border'>
                        {dagstaatoverzicht_employee}
                    </div>
                    <div id="employeedetails" className='employeedagstaatdetail'>
                        <div className='dagstaat_medewerkerdetailformHeader'> <p className='dagstaatparagraaf'>Medewerker</p><p className='dagstaatparagraaf'>kamer/AD</p><p></p><p className='dagstaatparagraaf dagstaat_rightalign'>norm</p><p className='dagstaatparagraaf dagstaat_rightalign'>taakduur</p><p></p><p className='dagstaatparagraaf dagstaat_rightalign'>Kuistype</p></div>
                        {dagstaatoverzicht}
                    </div>
                </div>

            </div>
        </>
    );
}
export default Dagstaat_per_medewerker;
